import React, { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import PropTypes from "prop-types";

function VandalismDropdown({
  label,
  vandalisms = [],
  langCode = "EN",
  callbackfunc,
  translatedComplaintCallback,
}) {
  const [selectedVandalism, setSelectedVandalism] = useState("");

  // On mount or when langCode changes, notify with initial selection
  useEffect(() => {
    if (translatedComplaintCallback) {
      translatedComplaintCallback(selectedVandalism);
    }
  }, [langCode, selectedVandalism, translatedComplaintCallback]);

  const handleSelect = (e) => {
    const selectedValue = e.target.value;
    setSelectedVandalism(selectedValue);

    // Find the vandalism object for selected id
    const vandalismObj = vandalisms.find(
      (v) => v.vandalismName.toString() === selectedValue
    );

    if (callbackfunc) {
      callbackfunc(
        selectedValue,
        vandalismObj
          ? vandalismObj.vandalismLabels.find(
              (label) => label.languageCode === langCode
            )?.name || vandalismObj.vandalismName
          : ""
      );
    }
  };

  return (
    <Form.Group as={Col} className="form-group">
      <Form.Label className="form-label">
        {label} <span style={{ color: "red" }}>*</span> :
      </Form.Label>
      <div className="select-wrapper">
        <Form.Select
          role="dropdown"
          id="complaintDropDown"
          className="complaint-select"
          value={selectedVandalism}
          onChange={handleSelect}
        >
          <option value=""></option>
          {vandalisms.map((vandalism) => {
            // Get label in current language or fallback to vandalismName
            const labelObj = vandalism.vandalismLabels.find(
              (lbl) => lbl.languageCode === langCode
            );
            const displayLabel = labelObj ? labelObj.name : vandalism.vandalismName;

            return (
              <option
                key={vandalism.vandalismCode}
                value={vandalism.vandalismCode}
                className="option"
              >
                {displayLabel}
              </option>
            );
          })}
        </Form.Select>
      </div>
    </Form.Group>
  );
}

VandalismDropdown.propTypes = {
  label: PropTypes.string,
  vandalisms: PropTypes.arrayOf(PropTypes.object),
  langCode: PropTypes.string,
  callbackfunc: PropTypes.func,
  translatedComplaintCallback: PropTypes.func,
};

export default VandalismDropdown;
